import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "262693482110"; // myFLOVEA — international format
const PRESET_MESSAGE_FR =
  "Bonjour myFLOVEA, j'ai une question sur le Coussin Massant Chauffant :";
const PRESET_MESSAGE_EN =
  "Hi myFLOVEA, I have a question about the Heated Massage Cushion:";

/**
 * Floating WhatsApp CTA — bottom-right, all pages.
 * Lifts objections in real time before purchase.
 */
const WhatsAppButton = ({ lang = "fr" }) => {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  // Show the button 3s after page load so it doesn't fight the initial paint.
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 3000);
    return () => clearTimeout(t);
  }, []);

  const isFr = lang === "fr";
  const msg = encodeURIComponent(isFr ? PRESET_MESSAGE_FR : PRESET_MESSAGE_EN);
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;

  if (!visible) return null;

  return (
    <div
      data-testid="whatsapp-widget"
      className="fixed z-50 bottom-24 right-4 md:bottom-6 md:right-6 flex flex-col items-end gap-3"
    >
      {expanded && (
        <div
          data-testid="whatsapp-bubble"
          className="bg-white border border-[#dcd7ce] rounded-lg shadow-[0_20px_50px_-20px_rgba(0,0,0,0.25)] px-4 py-3 max-w-[260px] text-sm animate-in fade-in slide-in-from-bottom-2"
        >
          <button
            type="button"
            onClick={() => setExpanded(false)}
            className="absolute top-2 right-2 text-[#8a8378] hover:text-[#3D2B1F]"
            aria-label="Fermer"
          >
            <X size={14} />
          </button>
          <div className="font-serif-display text-base text-[#1A1A1A] pr-4">
            {isFr ? "Une question ? On te répond en direct." : "A question? We reply live."}
          </div>
          <p className="mt-1 text-[13px] text-[#4a4a4a] leading-snug">
            {isFr
              ? "Notre équipe est en ligne sur WhatsApp — réponse en moins de 5 minutes en journée."
              : "Our team is live on WhatsApp — replies within 5 minutes during the day."}
          </p>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-bubble-cta"
            className="mt-3 inline-flex items-center gap-2 bg-[#25D366] text-white px-4 py-2 rounded-md text-[12px] tracking-[0.14em] uppercase font-medium hover:bg-[#1DA851] transition-colors"
          >
            <MessageCircle size={14} strokeWidth={2} />
            {isFr ? "Ouvrir WhatsApp" : "Open WhatsApp"}
          </a>
        </div>
      )}

      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        data-testid="whatsapp-button"
        aria-label={isFr ? "Contacter sur WhatsApp" : "Contact on WhatsApp"}
        className="w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-[0_10px_30px_-10px_rgba(37,211,102,0.65)] flex items-center justify-center transition-all hover:scale-105"
      >
        <MessageCircle size={26} strokeWidth={1.8} />
      </button>
    </div>
  );
};

export default WhatsAppButton;
